export default __webpack_public_path__ + "static/media/cover4.91565b6c.jpg";